export class Contact {
    Id: string;
    Tenant: Number;
    EnglishName: string;
    Email: string;
    CompanyName: string;
    Mobile: string;
    BusinessPhone: string;
    Position: string;
}